import React from 'react';
import ProviderNewPage from '@/portal/routes/providers/new/Page.tsx';
import { ActionFunctionArgs } from 'react-router-dom';
import { createProvider } from '@/common/api';
import { ApiError } from '@/common/types/errors';

export async function action({ request }: ActionFunctionArgs) {
  const formData = await request.formData();

  try {
    const newProvider = await createProvider(formData);
    return {
      provider: newProvider,
      success: true,
      flash: {
        message: `${newProvider.firstName} ${newProvider.lastName} created successfully.`,
        type: 'success',
      },
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      if (error.status === 403) {
        return {
          success: false,
          flash: {
            message: 'Permission denied.',
            type: 'danger',
          },
        };
      }
    }
    return {
      success: false,
      flash: {
        message:
          error instanceof ApiError
            ? error.message
            : 'Something went wrong. Please try again later.',
        type: 'danger',
      },
    };
  }
}

const NewRoute: React.FC = () => {
  return <ProviderNewPage />;
};

export default NewRoute;
